<div class="help__container d-flex flex-column justify-content-start align-items-center">
  <div class="notifications__panel-title d-flex align-items-center pt-3">
    <button class="notifications__panel-button" (click)="closeHelpCenter()">
      <mat-icon>close</mat-icon>
    </button>
    <h4 class="panel-title headline mb-0">Help Center</h4>
  </div>
  <!-- <span class="help__container-title mt-3">Help Center</span> -->
  <div class="w-100 d-flex justify-content-center align-items-center my-3" matTooltipClass="help__tooltip">
    <button mat-flat-button color="primary" style="width: 75%; line-height: 38px" (click)="openCustomerTraining()">
      Training Materials
    </button>
  </div>
  <div class="help__container-box mb-4">
    <h3 class="help__container-box--title subheadline">Frequently Asked Questions</h3>
    @if (isFetchingQuestions) {
      <div class="loading__container d-flex justify-content-center align-items-center">
        <mat-spinner class="mr-3" [diameter]="30"></mat-spinner>
        <span>Loading...</span>
      </div>
    }
    @if (!isFetchingQuestions) {
      <div class="box-accordion mt-3 mb-3">
        <mat-accordion>
          @for (faq of questions; track faq.question) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  {{ faq.question }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <p [innerHtml]="faq.answer"></p>
            </mat-expansion-panel>
          }
        </mat-accordion>
      </div>
    }
  </div>
  @if (showContactsCard) {
    <div class="help__container-box mb-4">
      <h3 class="help__container-box--title subheadline">Your UDT Team</h3>
      @if (isLoadingDepartments) {
        <div class="loading__container d-flex justify-content-center align-items-center">
          <mat-spinner class="mr-3" [diameter]="30"></mat-spinner>
          <span>Loading...</span>
        </div>
      }
      @if (!isLoadingDepartments) {
        <div class="mt-3 mb-3 box-accordion" style="width: 90%">
          <mat-accordion>
            @for (department of departments; track department.department; let i = $index) {
              <mat-expansion-panel [expanded]="i === 0">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{ department.department }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                @for (contact of department.contacts; track contact) {
                  <div class="contact__container">
                    <div class="contact__information--info d-flex align-items-center">
                      <div>
                        <img
                          class="contact__information-pic"
                          [src]="'../../../../../assets/profile-pictures/' + contact.email + '.png'"
                          onerror="
                            this.onerror = null;
                            this.src = '../../../../../assets/images/blue_font.png';
                          "
                        />
                      </div>
                      <div class="ml-3">
                        <p class="contact__information-data--name">{{ contact?.name }}</p>
                        <p class="contact__information-data--title">{{ contact?.title }}</p>
                        <p class="contact__information-data--title">
                          <img
                            class="contact__information-data--icon mx-1"
                            src="../../../assets/svg/phone-icon.svg"
                            alt="Phone Icon"
                          />
                          {{ contact?.phone | phoneNumber }}
                        </p>
                        <p class="contact__information-data--title d-flex">
                          <img
                            class="contact__information-data--icon mx-1"
                            src="../../../assets/svg/envelope-solid.svg"
                            alt="Envelop Icon"
                          />
                          {{ contact?.email }}
                        </p>
                      </div>
                    </div>
                  </div>
                }
              </mat-expansion-panel>
            }
          </mat-accordion>
        </div>
      }
    </div>
  }
</div>
